
import { Chevron, } from "@icons";



import type { TokenInfo, } from "@types";
import type {
	CSSProperties,
	FunctionComponent,
} from "react";
import type { TokenDefinition, } from "@bracket/addressbook";

import "./TokenPill.scss";



export declare type TokenPillProps = {
	token: TokenDefinition;
	chevron?: boolean;
	chevronDirection ?: "up" | "down";
	container?: boolean;
	disabled?: boolean;
	style?: CSSProperties;
	onClick?: ( token: TokenDefinition, ) => void;
};


export const TokenPill: FunctionComponent<TokenPillProps> = ({
	token,
	container = false,
	chevron = false,
	chevronDirection = "down",
	style = {},
	disabled,
	onClick = ( ) => { },
}) => {

	const classes = () => [
		`token-pill`,
		container ? "container" : null,
		disabled ? "disabled" : null,
	].filter(v => v).join(" ");

	const onSelect = ( ) => onClick(token);

	return (
		<div className={classes()} onClick={onSelect} style={style}>
			<div className="icon" style={{backgroundImage: `url(${token.logoURI})` }} />
			<div className="label">{token.label}</div>
			{ chevron && <Chevron style={{ transform: `rotate(${chevronDirection === "up" ? "180deg" : "0deg"} )`}} /> }
		</div>
	);

}
